<template>
  <div class="dashboard-container">
    <img :src="imgsrc" alt="" style="width:200px;height:200px;position: absolute;left: 42%;top:42%;">
  </div>
</template>

<script>

// import img from '../../assets/img/img.png'
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  data() {
    return {
      currentRole: 'adminDashboard',
      imgsrc: ''
    }
  },
  computed: {
    ...mapGetters([
      'roles'
    ])
  },
  created() {
    this.getImg()
  },
  methods: {
    async getImg() {
      //const res = await this.$api.post('/admin/other/get_indexpic')
	  const res = await this.$api.post('/admin/org/getQuotation')
	  if(res.data.length < 1){
		 const res = await this.$api.post('/admin/other/get_indexpic')
		 this.imgsrc = res.data.url
	  }else{
		  this.imgsrc = res.data.company_logo
	  }
      
    },
  }
}
</script>
<style scoped lang="scss">
// @import url();
.dashboard-container {
  width: 100%;
  height: 100%;
  /* background-image: url(''); */
  background-size: 100% 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
